// Button CTA block schema - Prominent call-to-action section
export const buttonCtaSchema = {
  type: 'button-cta',
  label: 'Call to Action',
  description: 'Prominent button with optional heading for conversions',
  icon: 'MousePointerClick',
  defaultContent: {
    heading: '',
    subheading: '',
    buttonText: 'Get Started',
    buttonLink: '',
    buttonStyle: 'primary', // 'primary' | 'secondary' | 'outline'
    alignment: 'center', // 'left' | 'center' | 'right'
    size: 'large', // 'medium' | 'large'
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading (optional)', type: 'text', placeholder: 'Ready to get started?' },
    { name: 'subheading', label: 'Subheading (optional)', type: 'text', placeholder: 'Join thousands of users...' },
    { name: 'buttonText', label: 'Button Text', type: 'text', placeholder: 'Get Started' },
    { name: 'buttonLink', label: 'Button Link', type: 'text', placeholder: 'https://...' },
    {
      name: 'buttonStyle',
      label: 'Button Style',
      type: 'select',
      options: [
        { value: 'primary', label: 'Primary (Filled)' },
        { value: 'secondary', label: 'Secondary (Dark)' },
        { value: 'outline', label: 'Outline' },
      ],
    },
    {
      name: 'alignment',
      label: 'Alignment',
      type: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    {
      name: 'size',
      label: 'Size',
      type: 'select',
      options: [
        { value: 'medium', label: 'Medium' },
        { value: 'large', label: 'Large' },
      ],
    },
  ],
};
